/*
 * Identifies which widget form produced a quote request. The backend maps these to the
 * request name shown in VMA, so the values must stay in sync with its WidgetRequestType enum.
 */
export const REQUEST_TYPES = {
    package: 'package',
    businessPackage: 'business_package',
    customQuote: 'custom_quote',
    host: 'host',
    contact: 'contact',
    appointment: 'appointment',
} as const;

export type RequestType = typeof REQUEST_TYPES[keyof typeof REQUEST_TYPES];
